module.exports = __webpack_public_path__ + "6c24205d4f2ecfe63967d2f61d48ce9d.png";